export enum Weights {
  KG = 'kg',
  LB = 'lb'
}
